<div class="row text-center">

    <div class="col">
        <i class="fas fa-spinner fa-spin fa-3x"></i>
      
    </div>


</div>